import { jsxs as l, jsx as c } from "react/jsx-runtime";
import { S as L, a as A, b as B, T as b } from "../../../../thumb-FTPDxW4I.js";
import { useState as P, useId as X } from "react";
import "../../../../button.types-BqgkEc5r.js";
import "../../button/iconButton/iconButton.js";
import "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import "../../tag/tag.js";
import "../../carousel/carousel.js";
import "../input/input.js";
import "../checkbox/checkbox.js";
import "../../../../phoneNumber-5ohMfWd7.js";
import "../dateRangePicker/dateRangePicker.js";
import "../../toast/toast.context.js";
import "../../../../map-DjiAXeob.js";
import { Flex as j } from "../../../layout/flex/flex.js";
const s = {
  "slider-component": "_slider-component_cups8_29",
  "slider-label": "_slider-label_cups8_29",
  "slider-label-with-value": "_slider-label-with-value_cups8_36",
  "slider-container-min-max": "_slider-container-min-max_cups8_42",
  "slider-min": "_slider-min_cups8_47",
  "slider-max": "_slider-max_cups8_48",
  "slider-root": "_slider-root_cups8_55",
  "slider-track": "_slider-track_cups8_64",
  "slider-range": "_slider-range_cups8_75"
}, C = 1, H = 1, v = "+", f = "-";
function rr({
  defaultValue: o = [0, 100],
  type: T = "range",
  minValue: d,
  maxValue: n,
  label: m,
  labelWithValue: _,
  typeRange: i,
  onChange: I,
  minValueText: p,
  maxValueText: u,
  chosenRangeText: x,
  hasPrefixMin: h = !1,
  hasSuffixMax: $ = !1
}) {
  const e = T === "range", E = e ? [o[0], o[1]] : [o[0]], [r, F] = P(E), S = X(), g = (a) => {
    F(e ? [a[0], a[1]] : [a[0]]), I(a);
  }, M = r[0] <= d && h ? `${f}${r[0]}` : r[0], k = r[1] >= n && $ ? `${r[1]}${v}` : r[1], N = (a, t) => e ? a === 0 ? `Minimum value: ${t}${i ? ` ${i}` : ""}` : `Maximum value: ${t}${i ? ` ${i}` : ""}` : `${m || "Slider"} value: ${t}${i ? ` ${i}` : ""}`;
  return /* @__PURE__ */ l("div", { className: s["slider-component"], children: [
    /* @__PURE__ */ l(j, { direction: "column", gap: "4", isFullWidth: !0, children: [
      m && /* @__PURE__ */ c("label", { htmlFor: S, className: s["slider-label"], children: m }),
      _ && /* @__PURE__ */ c("span", { className: s["slider-label-with-value"], dangerouslySetInnerHTML: { __html: _ } }),
      (p || u) && /* @__PURE__ */ l("div", { className: s["slider-container-min-max"], children: [
        /* @__PURE__ */ l("p", { className: s["slider-min"], children: [
          h && f,
          p,
          " ",
          i
        ] }),
        /* @__PURE__ */ l("p", { className: s["slider-max"], children: [
          u,
          $ && v,
          " ",
          i
        ] })
      ] })
    ] }),
    /* @__PURE__ */ c(
      L,
      {
        id: S,
        className: s["slider-root"],
        value: e ? [r[0], r[1]] : [r[0]],
        defaultValue: e ? [o[0], o[1]] : [o[0]],
        min: d,
        max: n,
        step: C,
        onValueChange: g,
        minStepsBetweenThumbs: H,
        "aria-label": m ? void 0 : `Slider from ${d} to ${n}`,
        children: /* @__PURE__ */ l(A, { className: s["slider-track"], children: [
          /* @__PURE__ */ c(B, { className: s["slider-range"] }),
          /* @__PURE__ */ c(b, { value: r[0], ariaLabel: N(0, r[0]) }),
          e && /* @__PURE__ */ c(b, { value: r[1], ariaLabel: N(1, r[1]) })
        ] })
      }
    ),
    e && /* @__PURE__ */ l("p", { className: s["slider-chosen-range"], children: [
      x,
      ": ",
      M,
      " - ",
      k,
      " ",
      i
    ] })
  ] });
}
export {
  rr as Slider
};
